import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_COOP_TRANSACTIONS } from "../../../config/api";

export const getCoopTransactions = createAsyncThunk(
  "coopTransactions/getAll",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: API_COOP_TRANSACTIONS,
        queryParams,
      });

      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);
